import { Type, inject } from '@angular/core';
import { ActivatedRoute, Data, ResolveFn } from '@angular/router';

import { Observable, filter, isObservable, of, switchMap } from 'rxjs';

export class RouteContext<TModel> implements Data {
    model: TModel;
}

export function use<
    TResolver extends {
        resolve: ResolveFn<TModel>;
    },
    TComponent,
    TModel,
>(resolver: Type<TResolver>): RouteContext<Type<TResolver>> {
    return {
        model: resolver,
    };
}

export function useResolverModel<TModel>(): Observable<TModel> {
    return inject(ActivatedRoute).data.pipe(
        filter((data) => 'model' in data),
        switchMap(({ model }) => (isObservable(model) ? model : of(model))),
    );
}
